import React, { Component } from "react";
import Dialog from "@material-ui/core/Dialog";

import { withDownloadUnitReport } from "../../../shared/containers/containerDownloadUnitReport";
import { withDownloadSavedReport } from "../../../shared/containers/containerDownloadSavedReport";

import Preloader from "../../../shared/items/static/preloader";
import Icon from "../../../shared/items/static/icon";
import { states } from "../../../reducers/queriesStates";

import styles from "./downloadReportsModal.module.scss";
import { withWinterMaintence } from "../../../shared/containers/containerWinterMaintence";

const modalClasses = {
  paper: styles.downloadReportsModal,
};

class DownloadReportsModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isModalOpen: false,
    };
  }

  componentDidUpdate(prevProps) {
    const { downloadUnitReportDataState, downloadSavedReportData, winterReportDownloadDataStrate } = this.props;

    if (
      (downloadUnitReportDataState === states.REQUEST && prevProps.downloadUnitReportDataState !== states.REQUEST) ||
      (downloadSavedReportData === states.REQUEST && prevProps.downloadSavedReportData !== states.REQUEST) ||
      (winterReportDownloadDataStrate === states.REQUEST && prevProps.winterReportDownloadDataStrate !== states.REQUEST)
    ) {
      this.setState({ isModalOpen: true });
    }

    if (
      (downloadUnitReportDataState !== states.REQUEST && prevProps.downloadUnitReportDataState === states.REQUEST) ||
      (downloadSavedReportData !== states.REQUEST && prevProps.downloadSavedReportData === states.REQUEST) ||
      (winterReportDownloadDataStrate !== states.REQUEST && prevProps.winterReportDownloadDataStrate === states.REQUEST)
    ) {
      this.setState({ isModalOpen: false });
    }
  }

  onCloseModal() {
    // this.setState({ isModalOpen: false });
  }

  render() {
    const { isModalOpen } = this.state;

    return (
      <Dialog classes={modalClasses} maxWidth="md" open={isModalOpen} onClose={this.onCloseModal.bind(this)}>
        <div className={styles.modalTitle}>
          <div className={styles.preloader}>
            <span>Скачивание... </span>
            <Preloader size={14} />
          </div>
          {/*     <span className={styles.close} onClick={this.onCloseModal.bind(this)}>
            <Icon name="x" />
          </span> */}
        </div>
      </Dialog>
    );
  }
}

export default withWinterMaintence(withDownloadUnitReport(withDownloadSavedReport(React.memo(DownloadReportsModal))));
